import { render, staticRenderFns } from "./BalanceAndHistoryBtn.vue?vue&type=template&id=aa940a3c&scoped=true"
import script from "./BalanceAndHistoryBtn.vue?vue&type=script&lang=js"
export * from "./BalanceAndHistoryBtn.vue?vue&type=script&lang=js"
import style0 from "./BalanceAndHistoryBtn.vue?vue&type=style&index=0&id=aa940a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa940a3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
